import { ITableModel } from '../interface';
import { IProducts } from 'models/Product';

import iconAvailability from 'img/icon-box.svg';
import ProductServices from 'services/product.service';
import ModelButton from 'components/ModelButton';
import { eventName, produtosAction } from 'components/ApplicationInsights/eventNames';

const _productServices = new ProductServices();

const labelCode = {
  label: 'Código',
  key: 'code',
  size: 120,
  maxSize: 120,
};

const labelCategory = {
  label: 'Categoria',
  key: 'category',
  size: 150,
  maxSize: 150,
};

const labelProduct = {
  label: 'Produto',
  key: 'name',
  size: 365,
  maxSize: 365,
};

const labelSubstance = {
  label: 'Substância',
  key: 'substance',
  size: 240,
  maxSize: 240,
};

const labelProducer = {
  label: 'Fabricante',
  key: 'producer',
  size: 170,
  maxSize: 170,
};

const labelAdditionalInformation = {
  label: 'Informação Adicional',
  key: 'additionalInformation',
  size: 200,
  maxSize: 200,
};

const labelEnterprise = {
  label: 'Empresa',
  key: 'enterpriseName',
  size: 120,
  maxSize: 120,
};

const availabilityActionButon = (title?: string, size?: number) =>
  ModelButton(
    title || '',
    iconAvailability,
    (data: IProducts) => _productServices.CheckAvailability(data),
    'Disponibilidade',
    size,
    produtosAction.ESTOQUEDISPONIVEL,
    eventName.PRODUTOS,
    undefined,
    'left'
  );

const productModel: Array<ITableModel> = [
  labelCode,
  labelCategory,
  labelProduct,
  labelEnterprise,
  labelSubstance,
  labelProducer,
  labelAdditionalInformation,
  /*availabilityActionButon('Disponibilidade', 135),*/
];

const openProtocolProductModel: Array<ITableModel> = [
  labelCode,
  labelCategory,
  { ...labelProduct, maxSize: 400 },
  labelEnterprise,
  labelSubstance,
  labelProducer,
  labelAdditionalInformation,
];

export { productModel, openProtocolProductModel };
